export function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return "";
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export function formatSlotTime(time) {
  if (!time) return "";
  const [hh, mm] = time.split(":");
  if (hh === "23" && mm === "59") return "24:00";
  return `${hh}:${mm}`;
}

export const formatToDecimals = (value, decimalPlaces) => {
  if (value === null || value === undefined || isNaN(value)) return "-";
  return Number(value).toFixed(decimalPlaces || 2);
};
